import React from 'react';
import '../assets/styles/style.css'; 
import { Link } from 'react-router-dom';
import FacebookIcon from '../assets/images/facebook-icon.png';
import InstagramIcon from '../assets/images/instagram-icon.png';
import TwitterIcon from '../assets/images/twitter-icon.png';
import TikTokIcon from '../assets/images/tiktok-icon.png';
import YouTubeIcon from '../assets/images/youtube-icon.png';
import CompanyLetter from '../assets/data/CompanyLetter.pdf';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="wave-footer"></div>
      <div className="footer-container">
        <div className="footer-column" id="contact">
          <h3>Contact</h3>
          <p style={{display: 'flex', gap: '10px', alignItems: 'flex-start'}}><span>Location:</span> <span>5th Floor F5-506, Ikaze House, Kisementi,Remera</span></p>
          <p style={{display: 'flex', alignItems: 'center', gap: '10px'}}><span>Email:</span> <span>info@songstarktours.com</span></p>
          <p style={{display: 'flex', alignItems: 'center', gap: '10px'}}><span>Tel:</span> <span>+250 794 422 747</span></p>
        </div>
        <div className="footer-column">
          <h3>Company</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/tours">Tours packages</Link></li>
            <li><Link to="/plan-trip">Plan your trip</Link></li>
            <li><Link to="/contact">Contact us</Link></li>
          </ul>
        </div>
        <div className="footer-column">
          <h3>Support</h3>
          <ul>
            <li><Link to="/contact">Get in Touch</Link></li>
            <li><Link to="/contact">Help center</Link></li>
            <li><Link to="https://wa.me/250794422747" target="_blank">Live chat</Link></li>
          </ul>
        </div>
        <div className="footer-column" id="newsletter">
          <h3>Terms & Conditions</h3>
          <p>Please read our terms and conditions carefully before booking our services.
            <span> <a href={CompanyLetter} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>Here</a></span>
          </p>
          <h3 id="h3-follow">Follow Us On</h3>
          <div className="social-icons">
            <Link to="https://www.facebook.com/profile.php?id=61561126642115" target="_blank"><img src={FacebookIcon} alt="Facebook" /></Link>
            <Link to="https://www.instagram.com/songstark_tours" target="_blank"><img src={InstagramIcon} alt="Instagram" /></Link>
            <Link to="https://twitter.com/songstarktours" target="_blank"><img src={TwitterIcon} alt="Twitter" /></Link>
            <Link to="https://www.tiktok.com/@songstarktours" target="_blank"><img src={TikTokIcon} alt="TikTok" /></Link>
            <Link to="https://www.youtube.com/@songstarktours" target="_blank"><img src={YouTubeIcon} alt="YouTube" /></Link>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; Copyright 2024. Song & Stark Cooperation Rwanda Ltd. All rights reserved</p>
      </div>
    </footer>
  );
}

export default Footer;